import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './context/AuthContext'
import { router } from './router'
import { createAppQueryClient } from './lib/queryClient'

/** Single app-scoped client; cleared on every identity transition via AuthProvider. */
export const appQueryClient = createAppQueryClient()

function App() {
    return (
        <QueryClientProvider client={appQueryClient}>
            <AuthProvider queryClient={appQueryClient}>
                <RouterProvider router={router} />
            </AuthProvider>
        </QueryClientProvider>
    )
}

export default App
